import { NgHttpCachingHeaders } from 'ng-http-caching';
export const CLIENT_CACHE_TAG_USERCHANGE = '_userDependent';
export const CLIENT_CACHE_PROTOCOL = 'CLIENT_CACHE_PROTOCOL';
export var ClientCacheRequestMode = /*#__PURE__*/function (ClientCacheRequestMode) {
  ClientCacheRequestMode["default"] = "default";
  ClientCacheRequestMode["skipCache"] = "skipCache";
  ClientCacheRequestMode["wipeCache"] = "wipeCache";
  return ClientCacheRequestMode;
}(ClientCacheRequestMode || {});
export var ClientCacheCustomHeaders = /*#__PURE__*/function (ClientCacheCustomHeaders) {
  ClientCacheCustomHeaders["WIPE_CACHE"] = "X-NG-HTTP-CACHING-WIPE-CACHE";
  return ClientCacheCustomHeaders;
}(ClientCacheCustomHeaders || {});
/**
 * sets up headers that should be applied even if ClientCache is disabled
 */
export function getUtilityHeadersForClientCache(mode = ClientCacheRequestMode.default) {
  const headers = {};
  if (mode === ClientCacheRequestMode.wipeCache) {
    headers[ClientCacheCustomHeaders.WIPE_CACHE] = "1";
  }
  return headers;
}
export function getHeadersForEnabledClientCache(config, tags = [], mode = ClientCacheRequestMode.default) {
  const headers = {};
  headers[NgHttpCachingHeaders.ALLOW_CACHE] = "1";
  const tagList = [...(Array.isArray(tags) ? tags : tags.split(','))];
  if (config !== true) {
    if (config.clearOnUserChange) tagList.push(CLIENT_CACHE_TAG_USERCHANGE);
    if (config.tags) tagList.push(...config.tags.split(','));
    if (config.seconds) headers[NgHttpCachingHeaders.LIFETIME] = (config.seconds * 1000).toString();
  }
  if (tagList.length) {
    headers[NgHttpCachingHeaders.TAG] = tagList.map(tag => tag.trim()).join(',');
  }
  return headers;
}
export function getClientCacheModelId(ModelCtor) {
  return 'model:' + ModelCtor.name;
}